module.exports = __webpack_public_path__ + "img/demo-csulb.14d752db.png";